import { render } from "./DishTypeFilterComponent.vue?vue&type=template&id=5ec08511&scoped=true"
import script from "./DishTypeFilterComponent.vue?vue&type=script&lang=js"
export * from "./DishTypeFilterComponent.vue?vue&type=script&lang=js"

import "./DishTypeFilterComponent.vue?vue&type=style&index=0&id=5ec08511&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec08511"]])

export default __exports__